









































































import { Component, Vue } from "vue-property-decorator";

import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class Integral extends Vue {
    showIntegral: boolean = false
    // 分页
    pageSize: number = 13;
    currentPage: number = 0;
    totalElements: number = 0;
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData()

    }
    closeIntegral() {
        this.showIntegral = false
    }
    mounted() {
        this.fetchData()
        this.jf()
    }
    list:any = []
    jfs:number = 0
    // 获取表格数据
    fetchData() {
        Vue.axios
            .get(`https://fc.hongfund.com:8802/vip/money/list?accountNo=${this.$store.state.account.no}&page=${this.currentPage}&size=${this.pageSize}`)
            .then((res) => {
                this.list = res.data.data.content
                this.totalElements = res.data.data.totalElements;
            });
    }
    jf() {
        Vue.axios
            .get(`https://fc.hongfund.com:8802/vip/money/count?accountNo=${this.$store.state.account.no}`)
            .then((res) => {
                this.jfs = res.data.data
            });
    }

}
